import React from "react";
import styles from './success.less';
import {Layout, Typography, Space } from "antd";
import {Link} from "react-router-dom";

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const Success = (props) => {
    const {name,
        phone,
        isHours,
        startDate,
        endDate,
        date,
        startHour,
        endHour,
        price} = props.location.state;
    return (
        <Layout>
            <Content className="success-layout-content">
                <Title type="success" level={2}>Đặt phòng thành công</Title>
                <Paragraph>Cảm ơn bạn đã đặt phòng, chúng tôi sẽ sẽ liên hệ lại qua <b>Zalo</b> và gửi bạn hướng dẫn thanh toán và check-in</Paragraph>
                <Title level={4}>Thông tin đặt phòng</Title>
                <Paragraph className="success-booking-info">
                    <ul className="success-list">
                        <li>
                            <Space>
                                <div className="success-label">Tên người đặt: </div>
                                <div className="success-content">{name}</div>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                <div className="success-label">Điện thoại: </div>
                                <div className="success-content">{phone}</div>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                <div className="success-label">Check-in: </div>
                                <div className="success-content">{isHours ? startHour + ' ' + date : '14:00 ' + startDate}</div>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                <div className="success-label">Check-out: </div>
                                <div className="success-content">{isHours ? endHour + ' ' + date : '12h00 ' + endDate}</div>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                <div className="success-label">Tổng tiền: </div>
                                <div className="success-content">{price} 000 VND</div>
                            </Space>
                        </li>
                    </ul>
                </Paragraph>
                <Link className="success-back-btn" to="/">Quay lại</Link>
            </Content>
        </Layout>
    );
}
export default Success;
